<template>
  <div class="matters-detail text-left">
    <template v-if="egress_profile.egress_profile_matters.length > 0">
      <!-- Buscador local: filtra por código/nombre de asignatura o nombre de sección -->
      <b-input-group
        v-if="egress_profile.egress_profile_matters.length > 5"
        size="sm"
        class="detail-search mb-2 noprint"
      >
        <b-input-group-prepend is-text>
          <b-icon icon="search"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          v-model="matter_search"
          type="search"
          :placeholder="
            $t('dashboard.directiveDashboard.searchEntityPlaceholder', {
              entity: $getVisibleNames(
                'mesh.egressprofilematter',
                true,
                'Asignaturas'
              ),
            })
          "
        ></b-form-input>
      </b-input-group>
      <!-- Sub-tabla con scroll y encabezado fijo -->
      <div class="detail-scroll">
        <b-table-simple small borderless class="detail-table mb-0">
          <b-thead>
            <b-tr>
              <b-th class="detail-th" style="width: 12%">{{
                $t("dashboard.directiveDashboard.code")
              }}</b-th>
              <b-th class="detail-th" style="width: 43%">{{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura"
                )
              }}</b-th>
              <b-th class="detail-th text-center" style="width: 15%">{{
                $t("dashboard.directiveDashboard.activeEntity", {
                  entity: $getVisibleNames(
                    "teaching.section",
                    true,
                    "Secciones"
                  ),
                })
              }}</b-th>
              <b-th
                v-if="hasSectionsDetail"
                class="detail-th"
                style="width: 30%"
                >{{
                  $getVisibleNames("teaching.section", true, "Secciones")
                }}</b-th
              >
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="matter in filteredMatters"
              :key="'directive-dashboard-matter-' + matter.id"
            >
              <b-td class="detail-td">{{ matter.matter_code }}</b-td>
              <b-td class="detail-td">{{ matter.matter_name }}</b-td>
              <b-td class="detail-td text-center">{{
                matter.active_sections_count
              }}</b-td>
              <b-td v-if="hasSectionsDetail" class="detail-td">
                <template v-if="matter.sections && matter.sections.length > 0">
                  <span
                    v-for="section in visibleSections(matter)"
                    :key="
                      'directive-dashboard-section-' +
                      matter.id +
                      '-' +
                      section.id
                    "
                    class="current-sections-item"
                  >
                    <b-link
                      :id="sectionPopoverId(matter, section)"
                      class="kl-chip mr-1"
                      :class="{
                        'section-chip--active-test': section.has_test_in_progress,
                      }"
                      v-b-tooltip.hover.v-secondary.noninteractive="
                        section.has_test_in_progress
                          ? $t('dashboard.directiveDashboard.activeTestTooltip', {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                true,
                                'Evaluaciones'
                              ),
                            })
                          : ''
                      "
                    >
                      <b-icon
                        v-if="section.has_test_in_progress"
                        icon="broadcast"
                        class="section-chip__pulse mr-1"
                      ></b-icon>
                      {{ section.name }}
                      <b-icon
                        icon="chevron-down"
                        class="section-chip__caret ml-1"
                      ></b-icon>
                    </b-link>
                    <b-popover
                      :target="sectionPopoverId(matter, section)"
                      triggers="hover focus"
                    >
                      <template #title>{{
                        $t("section.sectionView.navigation")
                      }}</template>
                      <div class="section-nav-popover">
                        <b-button
                          variant="primary"
                          class="section-nav-btn"
                          @click="navigateToSection('NewFullGradingView', section.id)"
                          @contextmenu.prevent="
                            navigateToSection('NewFullGradingView', section.id, true)
                          "
                        >
                          {{
                            $t("section.sectionView.sectionNotes", {
                              entity: $getVisibleNames(
                                "teaching.section",
                                false,
                                "Sección"
                              ),
                            })
                          }}
                        </b-button>
                        <b-button
                          variant="primary"
                          class="section-nav-btn"
                          @click="
                            navigateToSection(
                              'EvaluatorEvaluationsListView',
                              section.id
                            )
                          "
                          @contextmenu.prevent="
                            navigateToSection(
                              'EvaluatorEvaluationsListView',
                              section.id,
                              true
                            )
                          "
                        >
                          {{
                            $t("section.sectionView.sectionEvaluations", {
                              evaluations: $getVisibleNames(
                                "evaluations2.evaluation",
                                true,
                                "Evaluaciones"
                              ),
                              entity: $getVisibleNames(
                                "teaching.section",
                                false,
                                "Sección"
                              ),
                            })
                          }}
                        </b-button>
                        <b-button
                          v-if="
                            institution &&
                            institution.kl_assessment &&
                            institution.show_kl_reports
                          "
                          variant="primary"
                          class="section-nav-btn"
                          @click="
                            navigateToSection('AssessmentRangeSectionView', section.id)
                          "
                          @contextmenu.prevent="
                            navigateToSection(
                              'AssessmentRangeSectionView',
                              section.id,
                              true
                            )
                          "
                        >
                          {{ $t("section.sectionView.assessmentReport") }}
                        </b-button>
                        <b-button
                          v-if="institution && institution.show_kl_reports"
                          variant="primary"
                          class="section-nav-btn"
                          @click="
                            navigateToSection('AssessmentStudentsView', section.id)
                          "
                          @contextmenu.prevent="
                            navigateToSection(
                              'AssessmentStudentsView',
                              section.id,
                              true
                            )
                          "
                        >
                          {{ $t("section.sectionView.assessmentByStudent") }}
                        </b-button>
                        <b-button
                          variant="primary"
                          class="section-nav-btn"
                          @click="
                            navigateToSection(
                              'ProfessorProgressionReportView',
                              section.id
                            )
                          "
                          @contextmenu.prevent="
                            navigateToSection(
                              'ProfessorProgressionReportView',
                              section.id,
                              true
                            )
                          "
                        >
                          {{
                            $t("section.sectionView.evaluationsProgression", {
                              entity: $getVisibleNames(
                                "teaching.section",
                                true,
                                "Secciones"
                              ),
                            })
                          }}
                        </b-button>
                      </div>
                    </b-popover>
                    <!-- Acceso rápido a los reportes de GeneralReport con los
                    filtros de la sección preseleccionados (componente compartido
                    con la vista de administrar secciones). -->
                    <SectionReportsNav
                      :egress_profile_id="egress_profile.id"
                      :egress_profile_matter_id="matter.id"
                      :section_id="section.id"
                      :plan_level="matter.plan_level"
                      :period_id="section.period_id"
                    ></SectionReportsNav>
                  </span>
                  <!-- Colapso de secciones: muestra las primeras N + botón "+X más" -->
                  <b-button
                    v-if="matter.sections.length > section_display_limit"
                    variant="none"
                    class="kl-chip kl-chip--solid chip-more mr-1 mb-1 noprint"
                    @click="toggleSections(matter.id)"
                  >
                    {{
                      isExpanded(matter.id)
                        ? $t("dashboard.directiveDashboard.showLess")
                        : $t("dashboard.directiveDashboard.showMore", {
                            count:
                              matter.sections.length - section_display_limit,
                          })
                    }}
                  </b-button>
                </template>
                <span v-else class="kl-text-muted">-</span>
              </b-td>
            </b-tr>
            <b-tr v-if="filteredMatters.length == 0">
              <b-td
                class="detail-td kl-text-muted text-center"
                :colspan="hasSectionsDetail ? 4 : 3"
              >
                {{ $t("dashboard.dashboardView.noDataMatchesSearch") }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </template>
    <template v-else>
      <div class="kl-text-muted p-2">
        {{
          $t("dashboard.directiveDashboard.noEntity", {
            entity: $getVisibleNames(
              "mesh.egressprofilematter",
              true,
              "Asignaturas"
            ),
          })
        }}
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DirectiveDashboardMatters",
  components: {
    SectionReportsNav: () => import("@/components/reports/SectionReportsNav"),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      matter_search: "",
      // Cantidad de chips de secciones visibles por asignatura antes del "+N más".
      section_display_limit: 6,
      // Ids de asignaturas con sus secciones expandidas.
      expanded_matter_ids: [],
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
    // Solo se muestra la columna de Secciones si el directivo tiene permiso
    // de edición sobre la carrera (el backend incluye "sections" en ese caso).
    hasSectionsDetail() {
      return this.egress_profile.egress_profile_matters.some(
        (matter) => matter.sections != null
      );
    },
    filteredMatters() {
      const search = this.matter_search.trim().toLowerCase();
      if (search == "") return this.egress_profile.egress_profile_matters;
      return this.egress_profile.egress_profile_matters.filter(
        (matter) =>
          (matter.matter_code || "").toLowerCase().includes(search) ||
          (matter.matter_name || "").toLowerCase().includes(search) ||
          (matter.sections || []).some((section) =>
            (section.name || "").toLowerCase().includes(search)
          )
      );
    },
  },
  methods: {
    isExpanded(matter_id) {
      return this.expanded_matter_ids.includes(matter_id);
    },
    toggleSections(matter_id) {
      const index = this.expanded_matter_ids.indexOf(matter_id);
      if (index == -1) this.expanded_matter_ids.push(matter_id);
      else this.expanded_matter_ids.splice(index, 1);
    },
    visibleSections(matter) {
      if (!matter.sections) return [];
      if (this.isExpanded(matter.id)) return matter.sections;
      return matter.sections.slice(0, this.section_display_limit);
    },
    sectionPopoverId(matter, section) {
      return "directive-dashboard-section-popover-" + matter.id + "-" + section.id;
    },
    // Navegación típica de sección (notas, evaluaciones, reportes), igual que
    // en SectionTable: click navega en la misma pestaña, click derecho abre
    // una nueva.
    navigateToSection(route_name, section_id, new_tab = false) {
      const route = { name: route_name, params: { section_id } };
      if (new_tab) {
        const url = this.$router.resolve(route).href;
        window.open(url, "_blank");
      } else {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style scoped>
.matters-detail {
  background: var(--kl-surface-muted);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-radius-md);
  padding: 8px;
}
.detail-search {
  width: 100%;
}
/* Input de búsqueda según el estándar (--kl-input-*) */
.detail-search >>> .input-group-text {
  background: var(--kl-surface);
  border: 1px solid var(--kl-input-border);
  border-right: none;
  border-radius: var(--kl-input-radius) 0 0 var(--kl-input-radius);
  color: var(--kl-text-muted);
}
.detail-search >>> input {
  border: 1px solid var(--kl-input-border);
  border-left: none;
  border-radius: 0 var(--kl-input-radius) var(--kl-input-radius) 0;
  font-size: var(--kl-input-fs);
  color: var(--kl-text-body);
}
.detail-search >>> input:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: var(--kl-shadow-focus);
}
/* Scroll acotado con encabezado fijo: con muchas asignaturas el detalle no
   desborda la tabla principal. */
.detail-scroll {
  max-height: 320px;
  overflow-y: auto;
  border-radius: var(--kl-radius-sm);
}
.detail-th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--kl-surface-muted) !important;
  color: var(--kl-text-muted) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-caption);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 6px 10px !important;
  border-bottom: 1px solid var(--kl-border) !important;
  vertical-align: middle;
}
.detail-td {
  color: var(--kl-text-body);
  font-size: var(--kl-fs-body);
  padding: 8px 10px !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
  vertical-align: middle;
}
.detail-table tbody tr:last-child > td {
  border-bottom: none !important;
}
/* Botón "+N más": mismo formato de chip, con cursor e interacción */
.chip-more {
  cursor: pointer;
  transition: background 0.2s ease;
}
.chip-more:hover {
  background: var(--kl-color-primary-hover);
  color: var(--kl-text-on-primary);
}
/* Sección con evaluaciones activas: chip resaltado en verde ("en vivo") con
   ícono pulsante, para diferenciarlo de las secciones sin evaluación en curso. */
.section-chip--active-test {
  background: rgba(46, 158, 91, 0.12);
  color: var(--kl-color-success);
  border-color: rgba(46, 158, 91, 0.4);
  font-weight: var(--kl-fw-semibold);
}
.section-chip__pulse {
  animation: section-chip-pulse 1.4s ease-in-out infinite;
}
@keyframes section-chip-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.45;
    transform: scale(0.82);
  }
}
@media (prefers-reduced-motion: reduce) {
  .section-chip__pulse {
    animation: none;
  }
}
/* Chip de sección clickeable: abre el popover de navegación.
   Cada grupo (chip + botón de reportes) se separa del siguiente para que no
   se vean pegados; el gap interno mantiene el chip y su botón agrupados. */
.current-sections-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 10px;
  margin-bottom: 4px;
}
.current-sections-item .kl-chip {
  cursor: pointer;
  /* El gap del contenedor separa el chip del botón; anulamos el mr-1 inline */
  margin-right: 0 !important;
}
/* Ícono que indica que el chip despliega un menú al pasar el mouse */
.section-chip__caret {
  font-size: 0.7em;
  opacity: 0.6;
  vertical-align: middle;
}
.current-sections-item .kl-chip:hover .section-chip__caret {
  opacity: 1;
}
/* Popover de navegación de sección (notas, evaluaciones, reportes): mismo
   formato de botón que .dropdown-class en DashboardNavigationButton (usado
   para navegar desde la asignatura y el perfil de egreso), para que la
   navegación se vea consistente en todo el dashboard directivo. */
.section-nav-popover {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
  max-width: 260px;
}
.section-nav-btn {
  width: 100%;
  /* Altura automática: los nombres largos de reporte pueden ocupar 2 líneas
     sin que se corte el texto (antes height:35px + padding:0 lo recortaba). */
  min-height: 35px;
  height: auto;
  border-radius: 4px;
  padding: 6px 10px;
  text-align: left;
  white-space: normal;
  line-height: 1.25;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}
</style>
